var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    y: 0.986,
    fill: "#1E0AF5",
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.417 11.82-1.25-1.25m2.087-3.125V6.82m1.642 1.275.442-.442m-.442 3.75.442.442m-3.75-3.75-.442-.442m4.4 2.083h.625m-6.616 4.946 3.849-3.85c.165-.164.247-.247.278-.342a.416.416 0 0 0 0-.257c-.03-.095-.113-.178-.278-.343l-.307-.307c-.165-.165-.248-.248-.343-.279a.417.417 0 0 0-.258 0c-.095.031-.177.114-.342.279l-3.85 3.849c-.164.165-.247.247-.278.342a.417.417 0 0 0 0 .258c.031.095.114.178.279.343l.307.307c.165.165.247.247.343.278a.417.417 0 0 0 .257 0c.095-.03.178-.113.343-.278Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5.986h10v10H5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.fc1a7fb948e3e7a6cabec53ad525274d.svg";
export { ForwardRef as ReactComponent };